import { render, staticRenderFns } from "./PlanSummary.vue?vue&type=template&id=b5d7b278&scoped=true&"
import script from "./PlanSummary.vue?vue&type=script&lang=js&"
export * from "./PlanSummary.vue?vue&type=script&lang=js&"
import style0 from "./PlanSummary.vue?vue&type=style&index=0&id=b5d7b278&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d7b278",
  null
  
)

export default component.exports